import { Languages, Sparkles } from "lucide-react";
import Button from "@/components/ui/Button";
import { cn } from "@/lib/utils";

type CatalogTranslatePanelProps = {
  hint: string;
  buttonLabel: string;
  onTranslate: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
};

/** Compact action to fill missing locales or refresh other languages from the source. */
export function CatalogTranslatePanel({
  hint,
  buttonLabel,
  onTranslate,
  isLoading = false,
  disabled = false,
  className,
}: CatalogTranslatePanelProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 rounded-lg border border-surface-200 bg-surface-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
    >
      <div className="flex min-w-0 items-start gap-3">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-primary-200 bg-primary-50 text-primary-600">
          <Languages className="h-4 w-4" aria-hidden />
        </span>
        <p className="text-pretty pt-0.5 text-[13px] text-surface-600">{hint}</p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        leftIcon={<Sparkles className="h-4 w-4" />}
        className="shrink-0 self-start sm:self-auto"
        onClick={() => onTranslate()}
        isLoading={isLoading}
        disabled={disabled}
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
